import { render } from "./Tours.vue?vue&type=template&id=d5c3ca92&scoped=true"
import script from "./Tours.vue?vue&type=script&lang=js"
export * from "./Tours.vue?vue&type=script&lang=js"

import "./Tours.vue?vue&type=style&index=0&id=d5c3ca92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c3ca92"]])

export default __exports__